import { FC } from 'react';
import { cn } from '@/shared/lib';
import { Button } from '@/shared/shadcn';
import { useTranslation } from 'react-i18next';

interface ControlButtonsProps {
  loading: boolean;
  className?: string;
  onSaveModal: VoidFunction;
  onCancelModal: VoidFunction;
}

export const ControlButtons: FC<ControlButtonsProps> = ({ onCancelModal, onSaveModal, loading, className }) => {
  const { t } = useTranslation();

  return (
    <div className={cn('flex justify-between gap-2 mt-3', className)}>
      <Button size='lg' className='w-full' variant='secondary' onClick={onCancelModal}>
        {t('actions.cancel')}
      </Button>
      <Button size='lg' className='w-full' onClick={onSaveModal} isLoading={loading}>
        {t('actions.save')}
      </Button>
    </div>
  );
};
